import {Injectable, OnDestroy} from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class BaseComponent implements OnDestroy {
    readonly destroyed$ = new ReplaySubject<boolean>(1);

    scrollToFirstInvalidElement() {
        setTimeout(() => {
            const firstInvalidControl: HTMLElement = document.querySelector(
                '.ng-invalid'
            );
            if (firstInvalidControl) {
                firstInvalidControl.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    }

    ngOnDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
